module.exports = __webpack_public_path__ + "img/phone_menu.9d828695.svg";